import React, { PureComponent } from "react";
import PageLink from "../../../components/Page/PageLink";
import Footer from "../../../components/Footer/Footer";
import WorkflowCompatibility from "../../../components/Workflow/WorkflowCompatibility";

class NL_Notification_view extends PureComponent {
  render() {
    return (
      <div className="row" id="nl_notification_view">
        <div className="col-md-6">
          <div className="contentLight">
            <section>
              <h2>NL.Notification.view</h2>
              <p>
                NL.Notification.view allows you to view the read and unread
                notifications associated with the logged in user.
              </p>
              <WorkflowCompatibility front={true} back={true} />
              <h3>Options</h3>
              <table>
                <tbody>
                  <tr>
                    <td className="b top">Option</td>
                    <td className="b top">Description</td>
                  </tr>
                </tbody>
              </table>
              <Footer
                section={this.props.section}
                article={this.props.article}
                routeParams={this.props.routeParams}
              />
            </section>
          </div>
        </div>
        <div className="col-md-6 darkCol">
          <div className="contentDark">
            <section>
              <h2>NL.Notification.view Example</h2>
              <p>This example view read and unread notifications.</p>
              <div className="darkCode">
                <div>
                  <span className="jsonP">var</span>{" "}
                  <span className="nodeCode">options</span>{" "}
                  <span className="jsonP">=</span>{" "}
                  <span className="jsonY">&#123;</span>
                </div>
                <div>
                  <span className="jsonY">&#125;</span>
                  <span className="jsonA">;</span>
                </div>
                <div>
                  <br />
                </div>
                <div>
                  <span className="jsonPink">NL</span>
                  <span className="jsonA">.</span>
                  <span className="nodeCode">Notification</span>
                  <span className="jsonA">.</span>
                  <span className="jsDeclaration">view</span>
                  <span className="jsonY">(</span>
                  <span className="nodeCode">options</span>
                  <span className="jsonA">, </span>
                  <span className="jsonP">function</span>
                  <span className="jsonA">(</span>
                  <span className="jsonPink">err</span>
                  <span className="jsonA">, </span>
                  <span className="jsonPink">data</span>
                  <span className="jsonA">) </span>
                  <span className="jsonA">&#123;</span>
                </div>

                <div className="i1">
                  <span className="jsonA">if (</span>
                  <span className="jsonPink">err</span>
                  <span className="jsonA">) </span>
                  <span className="jsonY">&#123;</span>
                </div>
                <div className="i2">
                  <span className="jsComment">// Failed</span>
                </div>
                <div className="i1">
                  <span className="jsonY">&#125;</span>
                  <span className="jsonA"> else </span>
                  <span className="jsonY">&#123;</span>
                </div>
                <div className="i2">
                  <span className="jsComment">// Success</span>
                </div>
                <div className="i1">
                  <span className="jsonY">&#125;</span>
                </div>

                <div>
                  <span className="jsonA">&#125;</span>
                  <span className="jsonY">)</span>
                  <span className="jsonA">;</span>
                </div>
              </div>
            </section>
          </div>
        </div>
      </div>
    );
  }
}

export default NL_Notification_view;



// WEBPACK FOOTER //
// ./src/components/knowlege/workflow/NL_Notification_view.js